// extracted by mini-css-extract-plugin
module.exports =  {"header":"ModalHeader__header","cross":"ModalHeader__cross"};